export type ManualTestFieldType = 'text' | 'number' | 'select' | 'date' | 'textarea';

export type ManualTestFieldDefinition = {
  id: string;
  label: string;
  type: ManualTestFieldType;
  required?: boolean;
  unit?: string;
  options?: string[];
  hint?: string;
};

export type ManualTestDefinition = {
  code: string;
  name: string;
  description?: string;
  category?: string;
  valueLabel?: string;
  defaultUnit?: string;
  requiresImage?: boolean;
  aiPrompt?: string;
  fields: ManualTestFieldDefinition[];
};

export type ManualTestConfigResponse = {
  definitions: ManualTestDefinition[];
};

export type ManualTestEntry = {
  id: string;
  patientId: string;
  testCode: string;
  testName: string;
  measuredAt: string;
  valueText: string | null;
  valueNumber: number | null;
  unit: string | null;
  category: string | null;
  imageUrl: string | null;
  imageStorageKey: string | null;
  fields: Record<string, unknown>;
  aiSummary: string | null;
  aiConfidence: number | null;
  aiModel: string | null;
  notes: string | null;
  createdBy: { id: string; firstName: string; lastName: string } | null;
  createdAt: string;
  updatedAt: string;
};

export type ManualTestImageInference = {
  testCode: string | null;
  testName: string | null;
  valueText: string | null;
  valueNumber: number | null;
  unit: string | null;
  category: string | null;
  confidence: number | null;
  summary: string | null;
  fields: Record<string, unknown>;
  raw: unknown;
  model: string | null;
};

export function formatManualTestDate(value?: string | null) {
  if (!value) return '-';
  return new Date(value).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' });
}

export function toCodeLabel(code: string) {
  return code
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/\b\w/g, (token) => token.toUpperCase());
}
